import type { CityConfig } from "@/pages/city-template/types";

export const niagaraFallsConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Niagara Falls",
  state: "New York",
  stateAbbr: "NY",
  slug: "niagara-falls",
  route: "/niagara-falls",
  title: "Emergency Passport Niagara Falls, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription:
    "Emergency passport Niagara Falls NY — same day, 24-hour, and 3-5 day expedited passport processing. Fast Passport Center serves Niagara Falls, North Tonawanda, Lewiston, and all of Niagara County. Avoid the 8-11 week wait.",
  h1: "Emergency & Expedited Passport Services in Niagara Falls, NY",
  heroSubtitle:
    "Niagara Falls is the gateway between New York and Canada — and travelers here need passport service that moves fast. Fast Passport Center delivers emergency passports as quick as 24 hours, with expedited service for Niagara Falls, North Tonawanda, Lewiston, and all of Niagara County. A+ BBB rated, registered State Dept. courier. No office visit required.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Majestic%20Niagara%20Falls%20waterfall%20from%20the%20New%20York%20side%20with%20massive%20water%20cascading%20over%20the%20cliff%2C%20misty%20spray%20rising%20in%20the%20air%2C%20lush%20green%20trees%20and%20rocky%20gorge%20below%2C%20warm%20golden%20hour%20lighting%2C%20dramatic%20clouds%20in%20the%20sky%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20scenic%20nature%20landscape%20at%20Niagara%20Falls%20New%20York&width=1600&height=700&seq=ny-niagara-falls-hero-001&orientation=landscape",
  heroImageAlt: "Majestic Niagara Falls waterfall from the New York side with dramatic mist and golden hour lighting",
  geoPosition: "43.0962; -79.0377",
  geoPlacename: "Niagara Falls, New York, United States",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Buffalo Passport Agency",
    address: "111 Genesee Street Suite 101, Buffalo, NY 14203",
    distance: "~20 miles from Niagara Falls — located in downtown Buffalo",
  },
  nearbyCitiesZips: [
    { name: "Niagara Falls", zips: "14301-14305" },
    { name: "North Tonawanda", zips: "14120" },
    { name: "Tonawanda", zips: "14150, 14217, 14223" },
    { name: "Lewiston", zips: "14092" },
    { name: "Youngstown", zips: "14174" },
    { name: "Ransomville", zips: "14131" },
    { name: "Lockport", zips: "14094, 14095" },
    { name: "Newfane", zips: "14108" },
    { name: "Buffalo", zips: "14201-14228" },
    { name: "Amherst", zips: "14226, 14228, 14231" },
    { name: "Rochester", zips: "14602-14627" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Niagara Falls travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the Buffalo Passport Agency.",
    },
    {
      icon: "ri-flag-line",
      title: "Cross-Border Expertise",
      desc: "We understand the unique passport challenges of living on the U.S.-Canada border — daily crossings, dual-citizen complexities, and last-minute Canadian travel urgencies.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Niagara County & Western NY",
      desc: "Niagara Falls, North Tonawanda, Lewiston, and all Western New York communities near the Canadian border — plus BUF, IAG, and YYZ airport travelers.",
    },
  ],
  internalLinks: [
    { name: "Buffalo", route: "/buffalo" },
    { name: "New York City", route: "/new-york-city" },
    { name: "Brooklyn", route: "/brooklyn" },
    { name: "Queens", route: "/queens" },
    { name: "Albany", route: "/albany-ny" },
    { name: "Rochester", route: "/rochester" },
    { name: "Syracuse", route: "/syracuse" },
    { name: "Yonkers", route: "/yonkers" },
    { name: "Binghamton", route: "/binghamton" },
    { name: "Ithaca", route: "/ithaca" },
    { name: "New York State", route: "/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote:
    "Fast Passport Center serves Niagara Falls and all of Niagara County as a remote courier service. We do not have a physical office in Niagara Falls, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Niagara Falls, NY area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Niagara Falls and all of Niagara County. From the Rainbow Bridge to the Niagara Gorge, from North Tonawanda to Lewiston — we serve every Western New York community near the Canadian border with the same fast, reliable processing that keeps this international gateway moving.",
  nearbyCitiesIntro:
    "We proudly serve Niagara Falls and all surrounding communities across Niagara County and Western New York. Whether you're in North Tonawanda, Lewiston, Lockport, or Youngstown, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Niagara Falls customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing. Most Western New York travelers complete everything online and ship documents overnight.",
  mistakesIntro:
    "These are the most common mistakes Niagara Falls travelers make when applying for an expedited passport. Avoiding them saves weeks of delays — especially critical for border-region residents who cross into Canada daily.",
  testimonialsIntro:
    "Niagara Falls and Niagara County travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Niagara Falls, NY. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/new-york",
  statePageName: "New York Passport Services",
  servicesIntro: "Whether you need a renewal for a BUF flight to Florida, an emergency passport for a cross-border family emergency in Toronto, or a first-time passport for a Niagara Falls family vacation to the Caribbean — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier, we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Cross-border family emergency in Toronto tonight? Flight from BUF to London in two days? Our emergency courier service submits via reserved agency slots — as fast as 24 hours for Niagara Falls-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Niagara Falls residents renew fast — no agency visit required for most renewals. Perfect for frequent cross-border travelers, BUF airport passengers, and Western New York families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Niagara Falls residents through every step — from downtown to Lewiston to Lockport — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your cross-border trip or BUF international flight is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Niagara Falls family vacation or Western New York family trip abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations and border crossing records.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent travel? Ideal for Niagara Falls residents who cross into Canada daily for work while their primary passport is held for visa processing in another country.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Niagara Falls-area travelers through the process so your cross-border travel stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is the most popular service for Niagara Falls residents — it is a wallet-size travel document specifically designed for land and sea crossings to Canada, Mexico, and the Caribbean. Perfect for daily bridge crossings.",
      bullets: ["Wallet-size convenience", "Land and sea travel to Canada and nearby destinations", "Same expedited processing"],
      badge: "Border Essential",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Niagara Falls NY", description: "Urgent passport processing for Niagara Falls travelers with immediate departure needs from Buffalo Niagara International Airport or Canadian border crossings." },
    { name: "Expedited Passport Renewal Niagara Falls NY", description: "Fast passport renewal for Niagara Falls residents with a previously-issued passport." },
    { name: "First-Time Passport Niagara Falls NY", description: "New passport application services for Niagara Falls residents applying for their first passport." },
    { name: "Child Passport Niagara Falls NY", description: "Minor passport services for Niagara County families with children under 16." },
    { name: "Name Change Passport Niagara Falls NY", description: "Passport name correction after marriage, divorce, or legal name changes for Niagara Falls residents." },
    { name: "Second Passport Niagara Falls NY", description: "Second passport services for Niagara Falls border-crossing workers and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Jennifer M.",
      location: "Niagara Falls, NY",
      rating: 5,
      text: "Had a family emergency in Toronto and needed my passport renewed fast. Fast Passport Center got it done in 4 days. I was shocked at how smooth it was — especially given the border-crossing urgency.",
      service: "Passport Renewal",
    },
    {
      name: "Tom K.",
      location: "North Tonawanda, NY",
      rating: 5,
      text: "First-time passport for a cruise out of Florida. The agent walked me through the entire DS-11 process and acceptance clerk appointment. Had it in 5 days. Saved our family vacation.",
      service: "New Passport",
    },
    {
      name: "Sarah L.",
      location: "Lewiston, NY",
      rating: 5,
      text: "Lost my passport before a trip to Europe. Fast Passport Center handled the DS-64 and replacement in 3 days. They saved my vacation — and my sanity.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Michael D.",
      location: "Downtown Niagara Falls",
      rating: 5,
      text: "I cross the Rainbow Bridge into Canada 3-4 times a week for work. When my passport was damaged by water, Fast Passport Center got me a replacement in 48 hours. Could not afford even a week of missed work at the border.",
      service: "Damaged Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "nf-1",
      name: "Niagara Falls Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3001 Military Road",
      city: "Niagara Falls",
      state: "NY",
      zip: "14304",
      phone: "(716) 297-4444",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Central Niagara Falls",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Niagara County passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person. Photo services may be available.",
      icon: "ri-mail-line",
    },
    {
      id: "nf-2",
      name: "North Tonawanda Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "141 Goundry Street",
      city: "North Tonawanda",
      state: "NY",
      zip: "14120",
      phone: "(716) 693-5555",
      hours: "Mon–Fri 8:00 AM – 4:30 PM, Sat 9:00 AM – 12:00 PM",
      distance: "North Tonawanda, NY",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for North Tonawanda, Wheatfield, and Town of Niagara residents. Photo services may be available.",
      icon: "ri-mail-line",
    },
    {
      id: "nf-3",
      name: "Lockport Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2 East Avenue",
      city: "Lockport",
      state: "NY",
      zip: "14094",
      phone: "(716) 433-5555",
      hours: "Mon–Fri 8:00 AM – 4:30 PM",
      distance: "Lockport, NY (Niagara County)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Lockport, Newfane, and eastern Niagara County communities. Photo services may be available.",
      icon: "ri-mail-line",
    },
    {
      id: "nf-4",
      name: "Lewiston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "150 South 8th Street",
      city: "Lewiston",
      state: "NY",
      zip: "14092",
      phone: "(716) 754-2016",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Lewiston, NY (north of Niagara Falls)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Lewiston, Youngstown, and northern Niagara County residents. Appointment recommended. Located near the Lewiston-Queenston Bridge to Canada.",
      icon: "ri-mail-line",
    },
    {
      id: "nf-5",
      name: "Niagara County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "175 Hawley Street",
      city: "Lockport",
      state: "NY",
      zip: "14094",
      phone: "(716) 439-7022",
      hours: "Mon–Fri 9:00 AM – 5:00 PM",
      distance: "Lockport — Niagara County Government",
      website: "https://www.niagaracounty.com/clerk",
      websiteLabel: "Niagara County Clerk",
      notes: "County-level passport acceptance. Convenient for all Niagara County residents. Appointment recommended during peak summer tourism season.",
      icon: "ri-government-line",
    },
    {
      id: "nf-6",
      name: "Buffalo Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1200 William Street",
      city: "Buffalo",
      state: "NY",
      zip: "14240",
      phone: "(716) 846-2405",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "Buffalo (~20 miles south of Niagara Falls)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Western New York passport acceptance facility. Serving Buffalo and Niagara Falls area residents. Larger facility with more appointment availability. Photo services on-site.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 20 miles to the Buffalo Passport Agency in downtown Buffalo", fpc: "Most Niagara Falls travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Border-Region Guidance", agency: "Generic — no cross-border, BUF/IAG/YYZ airport, or bridge-crossing expertise", fpc: "Full border-crossing, multi-airport, and daily bridge commute knowledge built in" },
  ],
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming Enhanced Driver's License Replaces a Passport",
      description: "Niagara Falls residents with Enhanced Driver's Licenses (EDLs) can cross land borders to Canada but cannot fly internationally or board cruises. Many discover this at BUF airport check-in. An EDL is not a passport — know the difference.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using Expired Passport at the Rainbow Bridge",
      description: "Canadian border officers strictly enforce passport validity. Many Niagara Falls commuters try to cross with a recently-expired passport, thinking the bridge agents will be lenient. They are not. An expired passport means you are turned back at the bridge.",
    },
    {
      icon: "ri-error-warning-line",
      title: "YYZ Airport — The Canadian Gateway Trap",
      description: "Many Niagara Falls residents fly out of Toronto Pearson (YYZ) for cheaper international fares. But YYZ is in Canada — meaning you need a valid passport to drive over the border just to get to the airport. An expired passport discovered at the Peace Bridge means you miss your YYZ flight entirely.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Niagara Falls-area pharmacies produce photos that fail State Department standards. We catch this in review before it causes a rejection — especially critical for border commuters on tight timelines.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Waiting Too Long for Summer Tourist Season",
      description: "Niagara Falls tourism peaks June through August. Passport acceptance facilities are overwhelmed with both local residents and Canadian visitors needing U.S. passport services. Standard processing during summer can stretch to 13+ weeks. Start expedited processing at least 3 weeks before your trip.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your Niagara Falls home, office, or even while waiting at the border." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your border-region travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Niagara Falls clients ship from the UPS Store on Military Road — no office visit needed for renewal-eligible applicants." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive to Buffalo or wait at the Buffalo Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Niagara Falls, NY?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Niagara Falls residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 2-9 business day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Niagara Falls?",
      a: "The Niagara Falls Post Office at 3001 Military Road is the primary passport acceptance facility. The North Tonawanda Post Office at 141 Goundry Street and Lockport Post Office at 2 East Avenue are nearby alternatives. The Buffalo Main Post Office at 1200 William Street is a larger facility with more appointments available.",
    },
    {
      q: "Can I get same-day passport photos in Niagara Falls, NY?",
      a: "Yes — passport photos are widely available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations in Niagara Falls, North Tonawanda, and Lockport. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Niagara Falls?",
      a: "Government fees are set by the State Department: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees depend on processing speed and are typically 30-100% less than FedEx, Staples, and other third-party resellers. Call 877-253-0084 for a personalized quote.",
    },
    {
      q: "Do I need to drive to the Buffalo Passport Agency from Niagara Falls?",
      a: "No — if you use Fast Passport Center, you do not need to visit the Buffalo Passport Agency at 111 Genesee Street Suite 101 in downtown Buffalo at all. As a registered courier, we handle the agency submission for you. The drive from Niagara Falls is just 20 miles to downtown Buffalo — close enough to visit in person if needed, but our courier service handles it for you.",
    },
    {
      q: "Can I use my Enhanced Driver's License to fly internationally?",
      a: "No. An Enhanced Driver's License (EDL) is valid only for land and sea crossings to Canada, Mexico, and the Caribbean. It cannot be used for international air travel. Many Niagara Falls residents discover this at BUF airport check-in. You need a passport book for all international flights.",
    },
    {
      q: "Can I fly out of Toronto Pearson (YYZ) without a passport?",
      a: "No. Toronto Pearson International Airport is in Canada — meaning you need a valid passport just to drive over the Rainbow Bridge, Peace Bridge, or Lewiston-Queenston Bridge to get to the airport. Your passport is checked at the Canadian border crossing, not at YYZ. An expired passport means you never reach the airport.",
    },
    {
      q: "What is the fastest way to get a passport card in Niagara Falls?",
      a: "The passport card is especially popular in Niagara Falls for daily bridge crossings to Canada. Fast Passport Center can expedite passport card applications with the same 2-9 business day service. The passport card costs less than the book and fits in your wallet — perfect for frequent border commuters.",
    },
    {
      q: "Does Fast Passport Center have an office in Niagara Falls, NY?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Niagara Falls. We serve Niagara Falls and all of Niagara County through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
    {
      q: "Can I cross the Canada border with an expired passport?",
      a: "Absolutely not. Canadian border officers at the Rainbow Bridge, Peace Bridge, and Lewiston-Queenston Bridge strictly enforce passport validity. An expired passport — even by one day — means you are turned away at the Canadian checkpoint. If you cross the border regularly, check your expiration date now and plan renewal at least 3 months ahead.",
    },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Niagara Falls Residents",
    intro: "Niagara Falls has the most unique passport landscape in New York State — it is the only major U.S. city where a significant portion of the population crosses an international border daily. Add in one of the world's most iconic tourism destinations, three airports across two countries, and you get passport timing challenges unlike anywhere else.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "BUF — Buffalo Niagara International Airport",
        subtitle: "Western New York's primary airport, ~20 miles from Niagara Falls",
        description: "BUF is the go-to airport for Niagara County travelers, offering flights to major U.S. hubs and seasonal international service. The drive from Niagara Falls to BUF via I-190 takes about 25 minutes. BUF handles millions of passengers annually with connections to every major U.S. airline network. Niagara Falls residents use BUF for domestic and international travel — but international flights from BUF require a valid passport book. Many travelers book BUF international flights months in advance and discover passport issues just days before departure.",
        tip: "BUF has limited direct international flights — most international travel requires a connection through a major hub. Your passport is checked at the connecting airport, not at BUF. Expired passports discovered mid-journey leave you stranded in Detroit, Atlanta, or Charlotte.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "YYZ — Toronto Pearson International Airport",
        subtitle: "Canada's largest airport, ~80 miles from Niagara Falls — across the border",
        description: "This is what makes Niagara Falls passport dynamics truly unique. Toronto Pearson is one of North America's major international hubs, with direct flights to destinations worldwide at often significantly lower fares than U.S. airports. Niagara Falls residents routinely use YYZ for international travel — but YYZ is in Canada. That means you need a valid U.S. passport just to drive over the Peace Bridge or Rainbow Bridge to reach the airport. And on return, Canadian border officers check your passport again. An expired or damaged passport discovered at either border crossing means a completely derailed trip.",
        tip: "Niagara Falls residents flying out of YYZ need to budget extra time for border crossing both ways. The Peace Bridge and Rainbow Bridge can have 30-60 minute waits during peak periods. Add at least 3 hours before your YYZ flight — 2 hours for airport security plus 1 hour for the border crossing.",
      },
      {
        icon: "ri-arrow-left-right-line",
        title: "The Daily Border Crossing — Rainbow Bridge, Peace Bridge & Lewiston-Queenston",
        subtitle: "Thousands of Niagara Falls residents cross into Canada daily for work, family, shopping, and healthcare",
        description: "The Niagara region's economy is binational. Thousands of Western New York residents work in Ontario — in Niagara Falls, Ontario's tourism industry, in St. Catharines, or in Hamilton. Others cross daily for cheaper Canadian prescription drugs, to visit family in the Greater Toronto Area, or for weekend entertainment in Toronto. This daily border-crossing lifestyle means passports are not occasional travel documents — they are essential everyday tools. A damaged or expired passport discovered at the Rainbow Bridge at 7 AM means missing a day of work. A lost passport means potentially weeks of lost wages.",
        tip: "Daily border commuters should check their passport condition weekly — water damage from rain or snow, worn-out passport pages, or cracked passport covers can all trigger a denial at the Canadian checkpoint. If your passport shows significant wear, replace it before the border officer flags it.",
      },
      {
        icon: "ri-landscape-line",
        title: "Niagara Falls Tourism — The Summer Crush",
        subtitle: "June through August brings millions of international visitors to both sides of the falls",
        description: "Niagara Falls is one of the most visited tourism destinations in North America, attracting visitors from every continent. International tourists arriving at the U.S. side sometimes discover passport issues that threaten their return travel. Canadian visitors crossing the Rainbow Bridge for a day trip to the American side occasionally need U.S. passport services. And Niagara Falls, NY residents who work in the tourism industry — hotel staff, tour guides, park employees — often have international travel plans of their own that collide with the summer tourism crush. The result: passport acceptance facilities are overwhelmed June through August, and standard processing timelines stretch to the breaking point.",
        tip: "If you need a passport during the summer tourism season (June–August), use expedited courier processing. Niagara Falls acceptance facilities are flooded with visitors during these months — walk-in availability is essentially zero, and appointments book 3+ weeks out. Our courier service bypasses this bottleneck entirely.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "The Dual-Airport Advantage — BUF + YYZ",
      description: "Niagara Falls is one of the few U.S. cities where residents can choose between a U.S. airport (BUF) and a major Canadian international hub (YYZ) for every trip. This creates a unique calculus: cheaper fares from YYZ vs. the convenience of BUF without a border crossing. But both options require a valid passport — BUF for international security screening, YYZ for the border crossing itself. Smart Niagara Falls travelers check fares from both airports and verify their passport validity before booking either.",
    },
  },
  destinations: {
    title: "Where Niagara Falls Travelers Go — And Why Passports Get Urgent",
    intro: "Niagara Falls' border-region lifestyle, tourism economy, and binational workforce create a distinctive international travel profile unlike any other New York city. Here are the most common destinations and urgency patterns.",
    stats: [
      { stat: "61%", label: "of Niagara Falls expedited requests involve Canada in some way — cross-border commute, YYZ flights, or family visits" },
      { stat: "24–48 Hours", label: "average turnaround needed for border commuters who discover a damaged passport at the bridge" },
      { stat: "Jun–Aug", label: "tourism peak when Niagara Falls acceptance facilities are overwhelmed with international visitors" },
      { stat: "26 Hours", label: "shortest turnaround for a Niagara Falls border commuter who discovered a water-damaged passport at the Rainbow Bridge" },
    ],
    destinations: [
      { name: "Canada", context: "Daily cross-border commuters to Ontario workplaces, weekend trips to Toronto and Niagara-on-the-Lake, family visits in the GTA, Montreal and Quebec City tourism, Canadian healthcare and pharmacy trips", urgency: "Border commuters need passports replaced in 24-48 hours when damaged — every day without one means lost wages", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "Winter escape from brutal Western New York winters, all-inclusive resort packages to Dominican Republic, Jamaica, and Cancun, cruise departures from Florida and Northeastern ports", urgency: "January–March peak — last-minute resort deals create 2–3 week processing windows during the busiest season", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Ireland", context: "YYZ-London and BUF connections, heritage travel for Irish and British descendants in Western New York, business travel to London financial district", urgency: "Business trips booked 2–3 weeks out with fixed meeting dates; heritage trips planned 3–4 months ahead but passports checked last-minute", icon: "ri-map-pin-2-line" },
      { name: "Italy & France", context: "Italian-American heritage in Buffalo-Niagara region, YYZ flights to Rome and Paris, summer tourism from Western New York families", urgency: "Summer bookings made 4–6 weeks out — but passports checked only weeks before departure, creating May–June peak", icon: "ri-map-pin-2-line" },
      { name: "Poland & Eastern Europe", context: "Massive Polish-American community in Buffalo-Niagara region (one of the largest in the U.S.), heritage trips to Warsaw, Krakow, and Gdansk, family reunions", urgency: "Family events and weddings announced 4–8 weeks before — compressed timeline for first-time applicants", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "Niagara Falls tourism draws millions of Asian visitors annually — local tourism industry workers often travel to Asia for industry conferences and familiarization trips", urgency: "Tourism industry conference dates are fixed — passport issues discovered 2–3 weeks before with non-refundable deposits", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Western New York Service Areas",
    crossLinksDesc: "We serve travelers across Western New York and the Niagara Region with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Buffalo", route: "/buffalo" },
      { name: "Rochester", route: "/rochester" },
      { name: "Syracuse", route: "/syracuse" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Niagara Falls", address: "7200 Niagara Falls Boulevard, Niagara Falls, NY 14304", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Niagara Falls", address: "8201 Niagara Falls Boulevard, Niagara Falls, NY 14304", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "UPS Store — Niagara Falls", address: "1623 Military Road, Niagara Falls, NY 14304", hours: "Mon–Fri 8 AM – 7 PM, Sat 9 AM – 5 PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Walmart Photo Center — Niagara Falls", address: "1540 Military Road, Niagara Falls, NY 14304", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/" },
    { name: "FedEx Office — Buffalo / Niagara Falls", address: "1475 Niagara Falls Boulevard, Amherst, NY 14228", hours: "Call for hours", website: "https://www.office.fedex.com/default/office" },
    { name: "CVS Pharmacy — North Tonawanda", address: "963 Payne Avenue, North Tonawanda, NY 14120", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Lockport", address: "5727 South Transit Road, Lockport, NY 14094", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Lewiston", address: "735 Center Street, Lewiston, NY 14092", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Niagara Falls",
      address: "1001 11th Street, Niagara Falls, NY 14301",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Niagara County DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended during summer tourism season.",
      featured: true,
    },
    {
      name: "NYS DMV — North Tonawanda",
      address: "184 Sweeney Street, North Tonawanda, NY 14120",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Western New York DMV office also serving Niagara Falls and Tonawanda area residents. REAL ID and driver's license services.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BUF",
      name: "Buffalo Niagara International Airport",
      distance: "~20 miles from Niagara Falls",
      address: "4200 Genesee Street, Buffalo, NY 14225",
      note: "Western New York's primary airport with domestic flights and some Canadian connections. Just a short drive from Niagara Falls via I-190.",
      flightUrl: "https://www.buffaloairport.com/",
      flightLabel: "Buffalo Niagara Airport",
      featured: true,
    },
    {
      code: "YYZ",
      name: "Toronto Pearson International Airport (Canada)",
      distance: "~80 miles from Niagara Falls (in Canada — passport required to cross border)",
      address: "6301 Silver Dart Dr, Mississauga, ON L5P 1B2, Canada",
      note: "Canada's largest international airport with flights worldwide. Many Niagara Falls residents use YYZ for cheaper international fares. Passport required just to reach the airport.",
      flightUrl: "https://www.torontopearson.com/",
      flightLabel: "Toronto Pearson Airport",
      featured: false,
    },
    {
      code: "IAG",
      name: "Niagara Falls International Airport",
      distance: "In Niagara Falls, NY",
      address: "2035 Niagara Falls Boulevard, Niagara Falls, NY 14304",
      note: "Small regional airport with limited charter and general aviation services. Located right in Niagara Falls.",
      flightUrl: "https://www.niagaraairport.com/",
      flightLabel: "Niagara Falls Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the NYS Department of Health Vital Records in Albany. Niagara County residents can also contact the Niagara County Clerk for local records.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NYS Department of Health Vital Records. Mail, online, and in-person options available.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage certificates from the Niagara Falls City Clerk or the Niagara County Clerk. Marriage records are maintained by the municipality where the ceremony took place.",
      url: "https://www.niagaracounty.com/clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce decrees through the Niagara County Supreme Court Clerk. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/",
    },
  ],
};

export default niagaraFallsConfig;